import { useEffect } from "react";
import { FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../redux/store";
import { fetchSource, saveSource } from "../redux/slices/sourceSlice";

// The one switch that decides which accounting system the portal shows.
//
// It is global rather than per page or per user: the API stores it, so an admin
// changing it here changes what every screen (and every client) is looking at.
// BILL and IES are different sources with the same real records in them, which
// is why the choice has to be made once instead of on each list.
export default function SourceSwitch() {
  const dispatch = useDispatch<AppDispatch>();
  const { source, options, labels, saving } = useSelector((state: RootState) => state.source);

  useEffect(() => {
    dispatch(fetchSource());
  }, [dispatch]);

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mr: 1, display: { xs: "none", md: "flex" } }}>
      <Typography variant="caption" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
        Data source
      </Typography>
      <FormControl size="small" variant="outlined" sx={{ minWidth: 128 }}>
        <Select
          value={source}
          disabled={saving}
          onChange={(event) => dispatch(saveSource(event.target.value))}
          sx={{ fontSize: 14, bgcolor: "background.paper" }}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {labels?.[option] ?? option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
